import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'seira-text-button',
	templateUrl: './text-button.component.html',
	styleUrls: ['./text-button.component.scss'],
})
export class TextButtonComponent {
	@Input() titulo: string;
	@Output() clicked = new EventEmitter<Event>();
}
